import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, AlertCircle } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* 404 Icon/Number */}
        <div className="mb-8">
          <div className="inline-flex items-center justify-center w-32 h-32 bg-blue-100 rounded-full mb-6">
            <AlertCircle className="w-16 h-16 text-blue-600" />
          </div>
          <h1 className="text-9xl font-bold text-gray-800 mb-4">404</h1>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Page Not Found</h2>
          <p className="text-lg text-gray-600 mb-8">
            Oops! The page you're looking for doesn't exist. It might have been moved, deleted, or you entered the wrong URL.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl"
          >
            <Home className="w-5 h-5 mr-2" />
            Go to Homepage
          </Link>
          <Link
            to="/book"
            className="inline-flex items-center justify-center px-6 py-3 bg-white text-blue-600 font-semibold rounded-lg border-2 border-blue-600 hover:bg-blue-50 transition-colors shadow-lg hover:shadow-xl"
          >
            <Search className="w-5 h-5 mr-2" />
            Book Tickets
          </Link>
        </div>

        {/* Helpful Links */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <p className="text-sm text-gray-500 mb-4">You might be looking for:</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/" className="text-blue-600 hover:text-blue-700 text-sm font-medium">
              Home
            </Link>
            <Link to="/book" className="text-blue-600 hover:text-blue-700 text-sm font-medium">
              Book Tickets
            </Link>
            <Link to="/routes" className="text-blue-600 hover:text-blue-700 text-sm font-medium">
              Routes
            </Link>
            <Link to="/schedules" className="text-blue-600 hover:text-blue-700 text-sm font-medium">
              Schedules
            </Link>
            <Link to="/contact" className="text-blue-600 hover:text-blue-700 text-sm font-medium">
              Contact
            </Link>
            <Link to="/about" className="text-blue-600 hover:text-blue-700 text-sm font-medium">
              About
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
